<div mat-dialog-title>
  <span>{{ data.title | decodeHtml | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<q9-info-message *ngIf="error" type="error">
  {{ error | translate }}
</q9-info-message>

<ng-container *ngIf="!loading(); else loader">
  <mat-dialog-content>
    <form [formGroup]="sfnLinkAttachmentForm" #form="ngForm" class="form-content">
      <q9-text-field
        formControlName="title"
        [isRequired]="true"
        [label]="'CORE.ATTACHMENTS.TITLE'"></q9-text-field>

      <div class="list-of-org-models-nodes">
        <ng-container *ngFor="let node of sfn.sfNode.refModelNodes">
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span>{{ node.refModel.name | decodeHtml }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-sf-node-info [rmn]="node"></app-sf-node-info>
          </mat-expansion-panel>
        </ng-container>
      </div>

      <q9-textarea-field
        formControlName="description"
        [minRows]="3"
        [maxRows]="10"
        [label]="'CORE.ATTACHMENTS.DESCRIPTION_LINKS_ACTIVITY' | translate"></q9-textarea-field>

      <q9-groups-select
        formControlName="groups"
        [setAllInitial]="data.action.type === ATTACHMENTS_ACTIONS.CREATE"></q9-groups-select>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <q9-secondary-button mat-dialog-close>
      {{ (isPreview ? 'CORE.ATTACHMENTS.CLOSE' : 'CORE.GENERAL.CANCEL_TITLE') | translate }}
    </q9-secondary-button>

    <q9-primary-button
      *ngIf="!isPreview"
      [isLoading]="isSubmitted"
      (click)="form.onSubmit($event); onSubmit()">
      {{ data.action.title || 'CORE.GENERAL.SAVE' | translate }}
    </q9-primary-button>

    <q9-primary-button (click)="openSFN()">{{ 'CORE.GENERAL.OPEN' | translate }}</q9-primary-button>
  </mat-dialog-actions>
</ng-container>

<ng-template #loader>
  <q9-content-loader [isLoading]="true"></q9-content-loader>
</ng-template>
